import { Navigate, useLocation } from "react-router-dom";
import { AUTH } from "@/lib/api";

/**
 * Route guard for the authenticated app surface.
 * Unauthenticated users are redirected to /login, preserving the
 * destination so login can send them back after signing in.
 */
export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!AUTH.token()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }
  return children;
}
